export const overrideActiveTab = (event, tabs, activeTab = "") => {
  if (activeTab) return activeTab.toLowerCase();
  if (event?.ended) return event?.hidePlacings ? "overview" : "placings";
  const currentRound = event?.status?.currentRound || 0;
  if (event?.started || currentRound > 0)
    return typeof tabs?.brackets === "undefined" ? "pairings" : "brackets";
  if (event?.teamPlayer?.id && event?.player?.id) return "team-details";
  if (event?.player?.id) return "player-details";
  return "overview";
};

export const overrideActiveTabOrganizer = (event, tabs, activeTab = "") => {
  if (activeTab) return activeTab.toLowerCase();
  if (event?.ended) return "placings";
  if (event?.started) return "pairings";
  return "roster";
};

export const getTab = (event, tabs, activeTab = "") => {
  const tab = overrideActiveTab(event, tabs, activeTab);

  if (typeof tabs[tab] === "undefined") {
    return event?.started ? tabs?.placings : 0;
  }

  return tabs[tab];
};

export const getTabOrganizer = (event, tabs, activeTab = "") => {
  const tab = overrideActiveTabOrganizer(event, tabs, activeTab);

  if (typeof tabs[tab] === "undefined") {
    return event?.started ? tabs?.placings : tabs?.roster || 0;
  }

  return tabs[tab];
};
